function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { SuperSubject } from '../../models';
export var BaseSubjectStore = /*#__PURE__*/ function() {
    "use strict";
    function BaseSubjectStore() {
        var _this = this;
        _class_call_check(this, BaseSubjectStore);
        _define_property(this, "state", void 0);
        _define_property(this, "select", function(fields) {
            var selectedFields;
            if (!Array.isArray(fields)) {
                selectedFields = [
                    fields
                ];
            } else {
                selectedFields = fields;
            }
            return selectedFields.reduce(function(obj, key) {
                var result = obj;
                result[key] = _this.state[key].observable$;
                return result;
            }, {});
        });
        _define_property(this, "dispatch", function(newState) {
            Object.keys(newState).forEach(function(key) {
                var subject = _this.state[key];
                subject.value = newState[key];
            });
        });
        this.state = this.initializeState();
    }
    _create_class(BaseSubjectStore, [
        {
            key: "initializeState",
            value: function initializeState() {
                var defaultValue = this.getDefaultValue();
                return Object.keys(defaultValue).reduce(function(obj, key) {
                    var result = obj;
                    result[key] = new SuperSubject(defaultValue[key]);
                    return result;
                }, {});
            }
        },
        {
            key: "getStateValue",
            value: function getStateValue() {
                var _this = this;
                return Object.keys(this.state).reduce(function(obj, key) {
                    var result = obj;
                    result[key] = _this.state[key].value;
                    return result;
                }, {});
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.dispatch(this.getDefaultValue());
            }
        }
    ]);
    return BaseSubjectStore;
}();
